// extracted by mini-css-extract-plugin
export default {"testimonial":"Testimonial_testimonial__WRuOO","name":"Testimonial_name__5XWOb","message":"Testimonial_message__tHith"};